export default __webpack_public_path__ + "static/media/ordens-de-servicos-abertas.2822372f.svg";